import { ScaleIcon } from '@heroicons/react/20/solid';
import WeightUnit from './weightUnit';

const Preference = ({ preference, updateUserPreference }) => {
  return (
    <div>
      <h1 className='text-xl font-bold'>Preference</h1>
      {/* <StartDay /> */}
      <WeightUnit
        icon={<ScaleIcon className='size-4' />}
        preference={preference}
        updateUserPreference={updateUserPreference}
      />
    </div>
  );
};

export default Preference;
